import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";
import {signInWithRedirect, signOut} from "aws-amplify/auth";


export const showErrorNotifications = (e: any) => {

    console.debug('handleAppSyncResponseException', e)

    if (typeof e.errors !== 'undefined' && e.errors.length > 0) {
        e.errors.forEach((error: { message: string; }) => {
            showErrorNotification(error.message);
        })
    }
}


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const showErrorNotification = (message = 'Error performing the operation') => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifyError = (e: any) => {

    console.trace(e);

    // Handle NotAuthorizedException specifically
    if (e.name === 'NotAuthorizedException' && e.message && e.message.includes('Token expired')) {
        notifySessionExpired();
        return;
    }

    if (typeof e.errors !== 'undefined' && Array.isArray(e.errors)) {
        e.errors.forEach((error: { message: string; }) => {
            showNotification({
                                 title: 'Error',
                                 icon: <AiOutlineExclamation/>,
                                 message: error.message,
                                 color: 'red',
                             });
        })
        return;
    }

    const message = e.message ? e.message : 'Error performing the operation'

    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    const noFederatedJwtMessage = 'no federated jwt'
    const tokenExpiredMessage = 'token expired'
    const invalidLoginTokenMessage = 'invalid login token'
    
    if (message.toLowerCase() === noCurrentUserMessage || 
        message.toLowerCase() === noFederatedJwtMessage ||
        message.toLowerCase().includes(tokenExpiredMessage) ||
        message.toLowerCase().includes(invalidLoginTokenMessage)) {
        notifySessionExpired();
    }

}

let isSigningOut = false;

export const notifySessionExpired = (message = 'Redirecting to login page... Please, wait!') => {

    if (isSigningOut) return;
    isSigningOut = true;

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });

    setTimeout(async () => {
        try {
            await signOut({ global: true });
            signInWithRedirect();
        } catch (error) {
            console.trace('Sign out error:', error);
            // Fallback to manual redirect if signInWithRedirect fails
            window.location.href = window.location.origin;
        }
    }, 1000);

};


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}